import {base, generateRequest} from '@/utils/request';

// 活动列表页
export const AddThumbs = params => {
  // {
  //   type_id: 2,
  //   content_id: 'caoxi_a1'
  // }
 return generateRequest('GET',`${base}/extra_data/setInt`, params, true);
}

export const GetList = params => {
  // {
  //   type_id: 2
  // }
 return generateRequest('GET',`${base}/extra_data/getList`, params, true);
}

export const H5Share = (url,params) => {
  
  return generateRequest('POST',url, params, true);

}



// WEBPACK FOOTER //
// ./src/api.js